module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nif(typeof(additionalCSSClass) === 'undefined'){\nadditionalCSSClass = '';\n}\n%>\n<div>\n<!-- PLUPLOADER -->\n<button class=\"upload <%= additionalCSSClass %>\" id=\"upload_<%- config.context || '~' %>_<%- config.mode %>\"><i class=\"fi fi-upload\" aria-hidden=\"true\"></i>&nbsp;&nbsp;<%= utils.i18next.__('button:upload.' + config.mode) %></button>\n<div class=\"progress\">\n<div class=\"background\"></div>\n<div class=\"content\">&nbsp;</div>\n</div>\n<div class=\"uploads\">\n</div>\n<div class=\"fileList\">\n<%\nif(model.uploads){\nvar u, file, iconHTML;\nfor(u in model.uploads){\nfile = model.uploads[u];\niconHTML = (file.extension ? '<i class=\"' + utils.media.file.getSymbolClass(file.extension) + '\" aria-hidden=\"true\"></i> ' : '');\n%>              <div class=\"element\" data-media-id=\"<%= file.id || file.mediaID %>\" data-media-index=\"<%= u %>\">\n<%\nif(config.deletableFiles){\n%>\n<div class=\"controls\">\n<i class=\"fi fi-trash\" data-type=\"delete\"></i>\n</div>\n<%\n}\n%>\n<a href=\"<%- file.url %>\" target=\"_blank\"><%-iconHTML %> <%= file.originalName %></a>\n</div>\n<%          }\n}\n%>\n</div>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/media/upload/plupload/plupload.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(typeof(additionalCSSClass) === 'undefined'){
additionalCSSClass = '';
}

    ; __line = 5
    ; __append("\n<div>\n<!-- PLUPLOADER -->\n<button class=\"upload ")
    ; __line = 8
    ; __append(escapeFn( additionalCSSClass ))
    ; __append("\" id=\"upload_")
    ; __append( config.context || '~' )
    ; __append("_")
    ; __append( config.mode )
    ; __append("\"><i class=\"fi fi-upload\" aria-hidden=\"true\"></i>&nbsp;&nbsp;")
    ; __append(escapeFn( utils.i18next.__('button:upload.' + config.mode) ))
    ; __append("</button>\n<div class=\"progress\">\n<div class=\"background\"></div>\n<div class=\"content\">&nbsp;</div>\n</div>\n<div class=\"uploads\">\n</div>\n<div class=\"fileList\">\n")
    ; __line = 16
    ; 
if(model.uploads){
var u, file, iconHTML;
for(u in model.uploads){
file = model.uploads[u];
iconHTML = (file.extension ? '<i class="' + utils.media.file.getSymbolClass(file.extension) + '" aria-hidden="true"></i> ' : '');

    ; __line = 22
    ; __append("              <div class=\"element\" data-media-id=\"")
    ; __append(escapeFn( file.id || file.mediaID ))
    ; __append("\" data-media-index=\"")
    ; __append(escapeFn( u ))
    ; __append("\">\n")
    ; __line = 23
    ; 
if(config.deletableFiles){

    ; __line = 25
    ; __append("\n<div class=\"controls\">\n<i class=\"fi fi-trash\" data-type=\"delete\"></i>\n</div>\n")
    ; __line = 29
    ; 
}

    ; __line = 31
    ; __append("\n<a href=\"")
    ; __line = 32
    ; __append( file.url )
    ; __append("\" target=\"_blank\">")
    ; __append(iconHTML )
    ; __append(" ")
    ; __append(escapeFn( file.originalName ))
    ; __append("</a>\n</div>\n")
    ; __line = 34
    ;           }
}

    ; __line = 36
    ; __append("\n</div>\n</div>")
    ; __line = 38
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/media/upload/plupload/plupload.ejs

}